/**
 * Professional Programs catalogue.
 * Add new programs here to grow the section. Each program can later have
 * its own detailed page (see MontessoriProgramPage as an example).
 *
 * Programs with `statusType: 'upcoming'` are gated behind the
 * FEATURES.SHOW_UPCOMING_PROGRAMS feature flag (see ProgramsPage / HomePage).
 */
import { libraryImages } from '../assets/imageLibrary';

export const PROGRAMS = [
  {
    id: 'montessori-applied',
    title: 'البرنامج التطبيقي القائم على فلسفة مونتيسوري',
    titleEn: 'Applied Program Based on the Montessori Philosophy',
    category: 'فلسفات تربوية تطبيقية',
    status: 'متاح للتسجيل',
    statusType: 'available',
    duration: '٨–١٢ أسبوعاً',
    audience: 'معلمات ومربيات الطفولة المبكرة، قيادات منشآت رياض الأطفال، ومشاريع التأسيس',
    summary:
      'برنامج تطبيقي متكامل يُقدّم فلسفة مونتيسوري كمنهج عمل فعلي داخل البيئة الصفية، ويُمكّن المشاركات من ترجمة المبادئ النظرية إلى ممارسات يومية مع الطفل.',
    image: libraryImages.saudiMontessoriSensorial,
    href: '/programs/montessori-applied',
    tags: ['تطبيقي', 'مونتيسوري', 'ممارسة صفية'],
  },
  {
    id: 'leadership-ec',
    title: 'برنامج قيادات الطفولة المبكرة',
    category: 'قيادة وإدارة',
    status: 'قريباً',
    statusType: 'upcoming',
    duration: '٦–١٠ أسابيع',
    audience: 'قيادات منشآت الطفولة المبكرة',
    summary:
      'برنامج متخصص لتطوير قدرات القيادات الإدارية في إدارة منشآت الطفولة المبكرة، يجمع بين القيادة التربوية والحوكمة المؤسسية.',
    image: libraryImages.saudiClassroomActivities,
    href: '/programs',
    tags: ['قيادة', 'حوكمة', 'تطوير مهني'],
  },
  {
    id: 'quality-program',
    title: 'برنامج الجودة والاعتماد',
    category: 'جودة واعتماد',
    status: 'قريباً',
    statusType: 'upcoming',
    duration: '٨–١٢ أسبوعاً',
    audience: 'فِرَق الجودة في منشآت الطفولة المبكرة',
    summary:
      'برنامج تأهيلي متكامل لفِرق الجودة، يُمكّنها من إدارة منظومة الجودة الداخلية والاستعداد لزيارات الاعتماد الوطنية والدولية.',
    image: libraryImages.documentationPlants,
    href: '/programs',
    tags: ['جودة', 'اعتماد', 'حوكمة'],
  },
  {
    id: 'training-of-trainers',
    title: 'برنامج إعداد المدربات في الطفولة المبكرة',
    category: 'تدريب وتأهيل',
    status: 'قريباً',
    statusType: 'upcoming',
    duration: '٦ أسابيع',
    audience: 'الكوادر المتقدمة الراغبة في التحول إلى مدربات معتمدات',
    summary:
      'برنامج عملي لتأهيل المدربات في تخصصات الطفولة المبكرة، يجمع بين مهارات التدريب وتصميم المحتوى وقياس الأثر.',
    image: libraryImages.leavesInquiry,
    href: '/programs',
    tags: ['تدريب', 'إعداد مدربين'],
  },
];
